import {
  getFormData,
  devOrProd,
  getInternationalPriceNuqlium,
  getNuqliumIndex
} from '../shared/utils';

const internationalPrice = getInternationalPriceNuqlium();

// NQ API - Get Nuqlium Index based on dev or prod
const devEndPoint =
  'https://staging-fa-v4.nq-api.net/api/sevenstore-109gxho7fd/';
const prodEndPoint = 'https://fa-v4.nq-api.net/api/sevenstore-k6mro0ewb9/';
const devEndPointDNS =
  'https://fa-stg.nuqlium.co.uk/api/sevenstore-109gxho7fd/';
const prodEndPointDNS =
  'https://footasylum.nuqlium.co.uk/api/sevenstore-k6mro0ewb9/';

// NQ API - New function to get the directory based on type.
const getDirectory = (type) => {
  switch (type) {
    case 'category':
      return 'listings';
    case 'categoryfeed':
      return 'category';
    case 'feed':
      return 'feeds';
    case 'zone':
      return 'zones';
    case 'predictive':
      return 'search';
    case 'block':
      return 'blocks';
    case 'recommendations':
      return 'recommendations';
    case 'product':
      return 'product';
    default:
      return type;
  }
};

// NQ API - Generate Params function
export const generateParams = (pageKey, variation, type) => {
  const payload = {
    //DataIndex: nuqliumDataIndex(),
    index: getNuqliumIndex(),
    output: 'json',
    pagetype: type,
    pagekey: pageKey,
    'settings[pricelist]': internationalPrice,
    'settings[variation]': variation,
    'settings[mode]': 'web'
  };
  const endPointUrl =
    (devOrProd === 'dev' ? devEndPoint : prodEndPoint) +
    getDirectory(type) +
    '/';
  const endPointUrlDNS =
    (devOrProd === 'dev' ? devEndPointDNS : prodEndPointDNS) +
    getDirectory(type) +
    '/';
  const endPointParams = getFormData(payload);
  // Log endpoint and payload
  //console.log('Endpoint:', endPointUrl);
  //console.log('Payload object:', payload);
  return {
    endPointUrl,
    endPointParams,
    endPointUrlDNS
  };
};
